import React from 'react';
import { ChevronSmallUp } from '../../../../components/Icons';
import ToolbarSmallButton from './ToolbarSmallButton';
export var TOOLBAR_COLLAPSE_BUTTON = 'toolbar-collapse';
var BUTTON_MORE_OPTIONS = {
  id: TOOLBAR_COLLAPSE_BUTTON,
  icon: ChevronSmallUp,
  title: 'Less options',
  onApply: function onApply(editor) {
    return editor.collapseToolbar();
  }
};

function ToolbarCollapse(_ref) {
  var editor = _ref.editor;
  return React.createElement(ToolbarSmallButton, {
    editor: editor,
    button: BUTTON_MORE_OPTIONS,
    style: {
      transform: 'rotate(90deg)'
    }
  });
}

export default React.memo(ToolbarCollapse);